var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{class:[_vm.absolute ? 'w-loader-absolute' : 'w-loader-relative'],attrs:{"indeterminate":!_vm.full,"height":2},model:{value:(_vm.fullValue),callback:function ($$v) {_vm.fullValue=$$v},expression:"fullValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }